export default __webpack_public_path__ + "static/media/md.f9eaa544.svg";